module.exports = __webpack_public_path__ + "static/media/ADDVA_MEAL.150a59e7.svg";